'use client';

import { c as _c } from "react/compiler-runtime";
import { Accordion } from '@/app/components/text-and-data-display/accordion';
import { useDisclosure } from '@/app/hooks/useDisclosure';
import { baseGridClassName, rowGapClassName } from '@/app/lcv/components/sections/compare/styles';
import { PRODUCT_COMPARE_DATA_GA, PRODUCT_COMPARE_DATA_TEST } from '@/app/lcv/components/sections/compare/tracking';
import type { CompareItemType, CompareListProps, CompareListType } from '@/app/lcv/components/sections/compare/types';
import { getCompareModelField, parsedCompareValue } from '@/app/lcv/components/sections/compare/utils';
import { COMPARE_TOGGLES } from '@/app/lcv/contents/compare';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
import { stripPTags } from '@/app/utils/format';
interface RowItemsProps extends CompareListProps {
  items: CompareItemType[];
}
const RowItems = ({
  items = [],
  values = [],
  lineupModelsGroup
}: RowItemsProps) => {
  return items.map((item, index) => values.map((value, valueIndex) => {
    const model = lineupModelsGroup[value];
    const itemValue = model ? parsedCompareValue(getCompareModelField(model, item.fieldKey), item) : 'ไม่มี';
    return <div key={`${item.fieldKey}${index}${valueIndex}`} {...createDataAttributes({
      test: `${PRODUCT_COMPARE_DATA_TEST.toggle}-${item.fieldKey}-${valueIndex}`
    })} className={cn('md:px-4', {
      'hidden lg:block': valueIndex === 2
    })}>
          <p className="font-noto-bold mb-1">{item.title}</p>
          <span>
            {Array.isArray(itemValue) ? itemValue.join(', ') : typeof itemValue === 'object' && itemValue !== null ? 'ไม่มี' : stripPTags(String(itemValue ?? 'ไม่มี'))}
          </span>
        </div>;
  }));
};
const borderBottomClassName = cn('before:pointer-events-none before:absolute before:inset-0 before:border-b before:border-gray-50');
interface ToggleRowProps extends CompareListProps {
  item: CompareListType;
  index: number;
}
const ToggleRow = t0 => {
  const $ = _c(21);
  const {
    item,
    values,
    lineupModelsGroup,
    index
  } = t0;
  useDisclosure();
  const [isOpen, t1] = useDisclosure(false);
  const {
    toggle
  } = t1;
  const t2 = item.title;
  const t3 = item.fieldKey;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn(baseGridClassName, rowGapClassName);
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== item.items || $[2] !== lineupModelsGroup || $[3] !== values) {
    t5 = <div className={t4}><RowItems items={item.items} values={values} lineupModelsGroup={lineupModelsGroup} /></div>;
    $[1] = item.items;
    $[2] = lineupModelsGroup;
    $[3] = values;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== item.title) {
    t6 = createDataGA({
      click: true,
      eventName: PRODUCT_COMPARE_DATA_GA.main,
      text: item.title,
      value: "Toggle spec"
    });
    $[5] = item.title;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isOpen) {
    t7 = cn("px-0 md:px-4", borderBottomClassName, {
      "before:hidden": isOpen
    });
    $[7] = isOpen;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("text-body-2 px-0", borderBottomClassName);
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = `${PRODUCT_COMPARE_DATA_TEST.toggle}-${index}`;
  let t10;
  if ($[10] !== t9) {
    t10 = createDataAttributes({
      test: t9
    });
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== isOpen || $[13] !== item.fieldKey || $[14] !== item.title || $[15] !== t10 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== toggle) {
    t11 = <Accordion title={t2} value={t3} isOpen={isOpen} content={t5} {...t6} className={t7} contentClassName={t8} {...t10} onChange={toggle} />;
    $[12] = isOpen;
    $[13] = item.fieldKey;
    $[14] = item.title;
    $[15] = t10;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = toggle;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
};
export const CompareTogglesList = ({
  values = [],
  lineupModelsGroup
}: CompareListProps) => {
  return COMPARE_TOGGLES.map((item, index) => <ToggleRow key={`row${index}`} item={item} values={values} index={index} lineupModelsGroup={lineupModelsGroup} />);
};